import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Mold, OrderDetail } from '../../types/mold';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

interface SuccessStateProps {
  items: Array<{
    moldId: string;
    orderId: string;
    details: OrderDetail;
    mold: Mold;
  }>;
}

const SuccessState: React.FC<SuccessStateProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto py-8">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-4">
          <CheckCircle2 className="w-20 h-20 text-green-500" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          สร้างใบงานสำเร็จ
        </h2>
        <p className="text-gray-600">
          ระบบได้สร้างใบงานเรียบร้อยแล้ว
          สามารถคลิกที่ใบงานเพื่อดูรายละเอียดเพิ่มเติม
        </p>
      </div>

      <div className="space-y-4 mx-2 sm:mx-16">
        {items.map((item) => (
          <div
            key={item.orderId}
            data-cy="mold-order"
            className="bg-white rounded-lg border border-gray-200 p-6 hover:border-blue-500 hover:bg-blue-50 hover:shadow-lg transition-all cursor-pointer group shadow-lg"
            onClick={() => navigate(`/mold-orders/${item.orderId}`)}
          >
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  ใบงานเลขที่ {item.orderId}
                </h3>
                <p className="text-sm text-gray-600">แม่พิมพ์ {item.mold.sbiId}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-blue-500 text-md hidden sm:inline">
                  ดูรายละเอียด
                </span>
                <ArrowRight className="text-blue-500 w-7 h-7 group-hover:translate-x-1 group-hover:text-blue-700 transition-transform" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-8 gap-4">
        <button
          onClick={() => navigate(ROUTES.DASHBOARD)}
          className="px-6 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
        >
          กลับไปหน้ารายการใบงาน
        </button>
        <button
          onClick={() => {
            navigate(ROUTES.CREATE_MOLD_ORDERS_MENU);
            window.location.reload();
          }}
          className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          สร้างใบงานใหม่
        </button>
      </div>
    </div>
  );
};

export default SuccessState;
